export enum SidenavState {
  Expanded = 'expanded',
  Collapsed = 'collapsed',
  CollapsedHover = 'collapsedHover',
  Mobile = 'mobile',
  MobileOpen = 'mobileOpen'
}
